import React from 'react';
import {useMemo} from 'react';
import {Button} from 'semantic-ui-react';
import makeComp from '../../util/profiler';
import LegacyWBIcon from '../elements/LegacyWBIcon';
import * as CG from './cg/graph';
import * as Op from './cg/ops';
import * as LLReact from './cg/cgreact';

const PageControls: React.FC<{
  rowsNode: CG.Node;
  pageSize: number;
  page: number;
  prevPage: () => void;
  nextPage: () => void;
}> = makeComp(
  ({rowsNode, pageSize, page, prevPage, nextPage}) => {
    const countNode = useMemo(() => Op.opCount({arr: rowsNode as any}), [
      rowsNode,
    ]);

    const countValue = LLReact.useNodeValue(countNode);

    // return <div>Row count: {value.result}</div>;
    const startIndex = pageSize * page;
    let endIndex = startIndex + pageSize;
    const totalItems = countValue.result;
    if (endIndex > totalItems) {
      endIndex = totalItems;
    }
    const onFirstPage = page === 0;
    const onLastPage = endIndex === totalItems;
    return (
      <div>
        {startIndex + 1}-{endIndex} of {totalItems}{' '}
        <Button.Group className="pagination-buttons">
          <Button
            size="tiny"
            className="wb-icon-button only-icon"
            disabled={onFirstPage}
            onClick={prevPage}>
            <LegacyWBIcon name="previous" />
          </Button>
          <Button
            size="tiny"
            className="wb-icon-button only-icon"
            disabled={onLastPage}
            onClick={nextPage}>
            <LegacyWBIcon name="next" />
          </Button>
        </Button.Group>
      </div>
    );
  },
  {id: 'ControlPage'}
);

export default PageControls;
